import { inject } from "@angular/core";
import { Route, UrlSegment } from "@angular/router";
import { pathnameToSolution, SOLUTION } from "./solution";
import { NEVER } from "rxjs";

export function handleSolutionChange(route: Route, segments: UrlSegment[]) {

    const fullFinalUrl = `/${segments.map(i => i.path).join("/")}`;
    const expectedSolution = pathnameToSolution(fullFinalUrl);
    const currentSolution = inject(SOLUTION);

    if (currentSolution && currentSolution !== expectedSolution) {

        window.location.href = fullFinalUrl;
        return NEVER;
    }

    return true;
}
